import React, { useEffect, useState } from 'react'
import './header-2025.styles.scss'
import { Link, useLocation } from 'react-router-dom';
import eln_logo from '@/assets/eln-logo-white.png';
import { useSelector } from 'react-redux';
import { version } from '../../changelog-version';
import UserIcon from '../SHARED/user-icon/user-icon.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faX } from '@fortawesome/free-solid-svg-icons';
import AdminSidebar from '../../pages/admin/admin-sidebar.component';
import elnLogo_blue from '@/assets/eln-logo-blue.png';

const Header2025 = ({
  tabs,
  platform,
  hideLinks
}) => {

  const currentUser = useSelector(state => state.userData.currentUser);
  const userProfile = useSelector(state => state.userData.userProfile);
  const dbData = useSelector(state => state.userData.dbData);
  const screenSize = useSelector(state => state.listsData.screenSize);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [returnUrl, setReturnUrl] = useState(null);
  const location = useLocation();

  useEffect(() => {
    let href = window.location.origin
    // console.log(window.location)
    let encoded = encodeURIComponent(href + `/sso/?token={token}&intendedurl=%2Fhome%2F`)
    // console.log(encoded)
    setReturnUrl(`https://eweb.ilprincipals.org/eweb/?Site=ipa&WebCode=LoginRequired&expires=yes&URL_success=${encoded}`)
  }, [window, setReturnUrl])

  return (
    <div className={`header-2025 ${screenSize}`}>

      <div className='header_logo_and_title'>
        <div className='flex-row'>
          {
            (
              (screenSize === 'mobile' || screenSize === 'tablet') &&
              location.pathname.includes('/admin/')
            )
              ?
              <div className='menu_icon_container'>
                <div
                  className={`menu_icon ${showMobileMenu ? 'active' : ''}`}
                  onClick={() => setShowMobileMenu(!showMobileMenu)}>
                  <FontAwesomeIcon icon={faBars} size="xl" />
                </div>
              </div>
              : ''
          }
          <div>
            <img
              className={`header_logo ${screenSize}`}
              src={eln_logo}
              alt='EdLeaders Network'
              title='EdLeaders Network' />
          </div>

          <div className='header_title'>
            {
              location.pathname.includes('/admin')
                ? 'ELN Eval Admin'
                : 'ELN Evaluation Portal'
            }
          </div>
        </div>
        {
          (hideLinks)
            ?
            <div></div>
            :
            <div className='header_links'>
              {/* {
                (currentUser)
                  ?
                  <Link className='uk-link-reset' to='/home'>
                    <div className='header_menu_item' >
                      Home
                    </div>
                  </Link>
                  : ''
              } */}
              {
                (dbData && dbData.Admin)
                  ?
                  <>
                    <Link className='uk-link-reset' to={
                      location.pathname.includes('/admin')
                        ? '/home'
                        : '/admin'
                    }>
                      <div className='header_menu_item' >
                        {
                          location.pathname.includes('/admin')
                            ? 'Home'
                            : 'Admin'
                        }
                      </div>
                    </Link>
                    <div className="menu_spacer"></div>
                  </>
                  : ''
              }



              {
                (userProfile && currentUser)
                  ?
                  // <Link className='uk-link-reset' to='/logout'>	
                  <div className='header_menu_item clickable'
                    onClick={() => setShowDropdown(!showDropdown)}>
                    {
                      screenSize !== 'mobile' &&
                      `${userProfile.fName} ${userProfile.lName}`
                    }
                    <UserIcon profile={userProfile} />
                  </div>
                  // </Link>
                  // :
                  // (returnUrl)
                  //   ?
                  //   <a className='uk-link-reset' href={returnUrl}>
                  //     <div className='header_menu_item allcaps' >
                  //       Login
                  //     </div>
                  //   </a>
                    : ''
              }

              <div className={`header_dropdown_menu_container ${showDropdown ? 'active' : ''}`}>
                <div className='dropdown-menu'>
                  <Link to="/home">Completed Evals</Link>
                  <Link to="/logout">Logout</Link>
                  <div className='meta'>{version}</div>
                </div>
              </div>


            </div>
        }
      </div>
      {
        (
          location.pathname.includes('/admin/') &&
          (screenSize === 'mobile' || screenSize === 'tablet')
        )
          ?
          <div className={`header_slideout_menu ${showMobileMenu ? "show" : ""}`}>
            <div 
              className='close-button'
              onClick={() => setShowMobileMenu(!showMobileMenu)}>
              <FontAwesomeIcon icon={faX} size='xl' />
            </div>
            <div className="g-space-2"></div>
            <div 
              className={`sidebar-left-container ${screenSize}`}
              onClick={() => setShowMobileMenu(false)}>
              <div className='header_slideout_menu_title'>
                <img src={elnLogo_blue} />
                <div className='header_slideout_menu_title_text'>
                  ELN Evaluation Platform<br />
                  Admin Menu
                </div>
              </div>
              <div className="g-space-2"></div>
              <AdminSidebar tabs={tabs} />
            </div>
          </div>
          : ''
      }
    </div>
  )
}

export default Header2025;